import { PayModifierCategory } from '@amzn/atoz-shiftapp-types';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { getDurationStr } from '@amzn/atoz-shiftapp-utilities';
import { Duration as luxonDuration } from 'luxon';
import { getAvgHourlyPay, getBasePay, getCurrencyCode, getTotalPay, formattedCurrency } from '../../../../utils';
import { startsAfterNow } from '../../../../utils';
export var useShiftPayBreakdown = function (_a) {
    var shift = _a.shift, payRates = _a.payRates, incentivePay = _a.incentivePay;
    var t = useTranslation().t;
    var mapIncentivesToDetailLineProps = function (payModifiers) {
        if (!payModifiers) {
            return null;
        }
        return payModifiers.map(function (payModifier) {
            var _a, _b, _c, _d, _e;
            var renderIncentive = !!formattedCurrency(payModifier.applicableNetAmount) &&
                !!formattedCurrency(payModifier.hourlyAdditionalCompensation) &&
                !!payModifier.category &&
                !!payModifier.timeRange;
            return {
                renderLine: renderIncentive,
                name: t("shift_management_shiftDetails_breakdown_".concat((_a = payModifier.category) === null || _a === void 0 ? void 0 : _a.toLowerCase())),
                rateStr: formattedCurrency(payModifier.hourlyAdditionalCompensation) || '',
                netAmountStr: formattedCurrency(payModifier.applicableNetAmount) || '',
                startTime: ((_b = payModifier.timeRange) === null || _b === void 0 ? void 0 : _b.start)
                    ? DateTime.fromISO((_c = payModifier.timeRange) === null || _c === void 0 ? void 0 : _c.start)
                    : null,
                endTime: ((_d = payModifier.timeRange) === null || _d === void 0 ? void 0 : _d.end)
                    ? DateTime.fromISO((_e = payModifier.timeRange) === null || _e === void 0 ? void 0 : _e.end)
                    : null,
                isSurge: payModifier.category ==
                    PayModifierCategory.HighDemandPremium
            };
        });
    };
    var shiftDuration = luxonDuration
        .fromISO(shift.duration.value)
        .as('hours');
    var shiftDurationStr = getDurationStr(shift.duration, true);
    var basePay = getBasePay(shiftDuration, payRates);
    var totalPay = getTotalPay(shiftDuration, payRates, incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers);
    var averageHourlyPay = getAvgHourlyPay(shiftDuration, totalPay);
    var currencyCode = getCurrencyCode(payRates === null || payRates === void 0 ? void 0 : payRates.currency, incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers);
    var totalPayStr = formattedCurrency({
        amount: totalPay,
        code: currencyCode
    });
    var averageHourlyPayStr = formattedCurrency({
        amount: averageHourlyPay,
        code: currencyCode
    });
    var renderAllLines = !!(payRates === null || payRates === void 0 ? void 0 : payRates.rate) && startsAfterNow(shift);
    var renderBaseLine = !!(payRates === null || payRates === void 0 ? void 0 : payRates.rate) &&
        !!formattedCurrency({
            amount: basePay.netWage,
            code: currencyCode
        });
    var shiftStartTime = DateTime.fromISO(shift.timeRange.start);
    var shiftEndTime = DateTime.fromISO(shift.timeRange.end);
    var renderShiftDifferentialLine = !!(payRates === null || payRates === void 0 ? void 0 : payRates.shiftDifferential) &&
        !!formattedCurrency({
            amount: basePay.netShiftDifferential,
            code: currencyCode
        });
    return {
        shiftDurationStr: shiftDurationStr,
        totalPayStr: totalPayStr,
        averageHourlyPayStr: averageHourlyPayStr,
        renderAllLines: renderAllLines,
        baseLineProps: {
            renderLine: renderBaseLine,
            name: t('shift_management_shiftDetails_breakdown_base'),
            rateStr: formattedCurrency({
                amount: payRates === null || payRates === void 0 ? void 0 : payRates.rate,
                code: currencyCode
            }) || '',
            netAmountStr: formattedCurrency({
                amount: basePay.netWage,
                code: currencyCode
            }) || '',
            startTime: shiftStartTime,
            endTime: shiftEndTime,
            dataTestId: 'ShiftPayBreakdownDetailLineBase'
        },
        shiftDifferentialLineProps: {
            renderLine: renderShiftDifferentialLine,
            name: t('shift_management_shiftDetails_breakdown_shiftDifferential'),
            rateStr: formattedCurrency({
                amount: payRates === null || payRates === void 0 ? void 0 : payRates.shiftDifferential,
                code: currencyCode
            }) || '',
            netAmountStr: formattedCurrency({
                amount: basePay.netShiftDifferential,
                code: currencyCode
            }) || '',
            startTime: shiftStartTime,
            endTime: shiftEndTime,
            dataTestId: 'ShiftPayBreakdownDetailLineShiftDifferential'
        },
        incentiveLinesProps: mapIncentivesToDetailLineProps(incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers)
    };
};
